module.exports = __webpack_public_path__ + "static/media/NoIcon.a0037723.png";